"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _contractCache, _contractCacheKey;
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
class ERC20Token {
    constructor(data, contractCache, contractCacheKey) {
        _contractCache.set(this, void 0);
        _contractCacheKey.set(this, void 0);
        __classPrivateFieldSet(this, _contractCache, contractCache);
        __classPrivateFieldSet(this, _contractCacheKey, contractCacheKey);
        this.id = data.id;
        this.name = data.name;
        this.symbol = data.symbol;
        this.decimals = data.decimals;
    }
    async totalSupply() {
        const token = await __classPrivateFieldGet(this, _contractCache).loadContractFromStateVariable(await __classPrivateFieldGet(this, _contractCache).loadContractFromOrg(utils_1.HATCH_APP), __classPrivateFieldGet(this, _contractCacheKey), 'erc20');
        return token.totalSupply();
    }
}
_contractCache = new WeakMap(), _contractCacheKey = new WeakMap();
exports.default = ERC20Token;
//# sourceMappingURL=ERC20Token.js.map